module.exports = __webpack_public_path__ + "assets/static/jpg/banner2-n.4250a5a48cb03fc4a3c97521c813c511.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/banner2-n.jpg
 ** module id = 487
 ** module chunks = 1
 **/